import React, { useEffect } from 'react';
import { webview } from '../../../app/api/webview';
import MobileView from './MobileView';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../Auth/authSlice';
import { encryptForResumeX } from '../../../utils/crypto';

const Connect = () => {
  const user = useSelector(selectCurrentUser);
  const navigate = useNavigate();
  const encryptedPassword = user?.password ? btoa(encryptForResumeX(user.password)) : '';
  useEffect(() => {
    const handlePopState = () => {
      navigate('/home/announcement/gatewaybox');
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'pageOpen', data: 'true' }));
    const handleMessage = (event) => {
      try {
        console.log('message', event.data);
        const message = event.data;
        if (message.type == 'GBOXClose') {
          // dispatch(toggleOutlet(false));
          navigate('/home/announcement/gatewaybox');
          console.log('GBOXClose');
        }
      } catch (error) {}
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
  return <MobileView URL={webview.Connect.ResumeX(user?.username, encryptedPassword)} comingSoon={false} />;
};

export default Connect;
